<!--
SPDX-FileCopyrightText: 2026 Max Booth

SPDX-License-Identifier: MPL-2.0
-->

<!-- Site mark: four quiz-answer tiles (the classic triangle/diamond/circle/square). -->
<script lang="ts">
	let { class: className = 'w-9 h-9' }: { class?: string } = $props();
</script>

<svg class={className} viewBox="0 0 64 64" aria-hidden="true">
	<rect width="64" height="64" rx="16" fill="#4f46e5" />
	<rect x="9" y="9" width="21" height="21" rx="5" fill="#f43f5e" />
	<rect x="34" y="9" width="21" height="21" rx="5" fill="#3b82f6" />
	<rect x="9" y="34" width="21" height="21" rx="5" fill="#f59e0b" />
	<rect x="34" y="34" width="21" height="21" rx="5" fill="#10b981" />
	<path d="M19.5 14.5l5.5 10h-11z" fill="#fff" />
	<path d="M44.5 13.5l6 6-6 6-6-6z" fill="#fff" />
	<circle cx="19.5" cy="44.5" r="5" fill="#fff" />
	<rect x="40" y="40" width="9" height="9" rx="1.5" fill="#fff" />
</svg>
